import Avatar from 'boring-avatars';
import { avatarColors, avatarSeed, avatarVariant } from '../../utils/entity_avatar';

/**
 * An entity's picture at `size` px: the uploaded image when there is one,
 * otherwise a generated avatar (see utils/entity_avatar.js). Purely
 * presentational — pass the entity object you already have.
 */
export function EntityImage({ entity, size = 32, square = false, style, className }) {
    const radius = square ? Math.max(2, Math.round(size / 8)) : '50%';
    if (entity?.image_url) {
        return (
            <img
                src={entity.image_url}
                alt=""
                width={size}
                height={size}
                className={className}
                style={{ width: size, height: size, borderRadius: radius, objectFit: 'cover', display: 'block', flexShrink: 0, ...style }}
            />
        );
    }
    return (
        <span className={className} style={{ display: 'inline-flex', lineHeight: 0, flexShrink: 0, ...style }} aria-hidden="true">
            <Avatar name={avatarSeed(entity)} variant={avatarVariant(entity?.entity_type)} colors={avatarColors(entity)} size={size} square={square} />
        </span>
    );
}

export default EntityImage;
